// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{.cf7d88 svg{display:none}}._45d78e{padding:.125em 0;min-width:4em}", ""]);
// Exports
exports.locals = {
	"navigator": "cf7d88",
	"date": "_45d78e"
};
module.exports = exports;
